import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import {AuthService} from '../../shared/auth.service';
import {companyTabAllowed} from './company-tabs';

// A hidden My company tab opened by URL lands on Profile instead of a page whose API 403s.
// Waits for the user like AuthGuard does; AuthGuard on the parent runs first.
@Injectable({providedIn: 'root'})
export class CompanyTabGuard {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.auth.user.pipe(filter(Boolean), take(1),
      map(() => companyTabAllowed(route.data.tab, this.auth) || this.router.createUrlTree(['/company/profile'])));
  }
}
